import React, { useEffect, useState } from 'react'
import BackButton from '../../../components/button/BackButton'
import { Navbar } from '../../../components/navbar/Navbar'
// import Checkbox from '../../../components/button/Checkbox'
import Input from '../../../components/input/Input'
import Table from '../../../components/table/Table'
import SearchInput from '../../../components/input/SearchInput'
import axios from "axios"
import DateFormatConverter from '../../../components/input/DateFormatConvert'
import { BACKEND_URL, E_immatriculation } from '../../../constants/constant'
function ConsultationImmatriculation() {

  const [Client , setClient ] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 
   const [ priseEnCharge , setPriseEnCharge] = useState([]);

   
  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${BACKEND_URL}/prisecharge`)
      .then((response) => setPriseEnCharge(response.data))
      .catch((error) => {console.error(error);alert(`Il y a une erreur :  ${error}`)});
  }, []);
 
  useEffect(() => {
   // Récupérer les données depuis le backend
   axios.get(`${E_immatriculation}/contribuable`)
     .then((response) => setClient(response.data))
     .catch((error) => {console.error(error);alert(`Il y a une erreur :  ${error}`)});
 }, []);

 const handleSearch = (e) => {
   setSearchTerm(e.target.value);
 };   

const filteredData = Client.filter((client) => 
 client.id && client.id.toLowerCase().includes(searchTerm.toLowerCase()) && client.valide === true && client.bloque === false && client.deces === false && client.radie === false && client.cessation === false 
 );
 

// Header table client
const ClientHeaders = ["Ref démandé", "Raison social",  "Référence Fiscal" , "type" , " Date autorisation" , "Régime fiscal" , "Forme juridique" , "Date de création" , "RIB"];
// Data client Table
const ClientData = filteredData.length > 0 ? 
filteredData
  .filter(item => priseEnCharge.some(pec => pec.id_contribuable === item.id)) // Filtrer les éléments qui ne sont pas dans priseEnCharge
  .map((item) => ([ 
    item.id, 
    item.raison_social, 
    item.reference_fiscal, 
    item.type,
    <DateFormatConverter isoDate={item.date_agrement} />,
    item.regime_fiscal,
    item.forme_juridique,
    <DateFormatConverter isoDate={item.date_creation} />,
    item.rib
  ])) : 
[["Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune", "Aucune"]];


 // Nombre de données filtrées
 const dataCount = ClientData.length === 0 || (ClientData[0] && ClientData[0][0] === "Aucune") ? 0 : ClientData.length;


  const Navbarcontent = (
    <div className='flex justify-between '>
      <div className='text-white font-semibold '>
      Consultation 
     </div>
     <div>
<BackButton to="/consultatioRF"></BackButton>
     </div>
    </div>
 )
  return (
    <div  className='bg-[#212122] h-screen w-screen'>
    <Navbar content={Navbarcontent}></Navbar>
    <div className="m-4">
<div className='bg-black p-4 flex justify-between'>
<div className='flex flex-col'>
<SearchInput onChange={handleSearch}></SearchInput>
</div>
</div>
<div className='flex justify-center'>
<div className='overflow-y-auto w-[1480px]  mt-4'>
{ClientData.length === 0 ? (
  <div className="text-white text-center mt-4">Aucune donnée disponible</div>
) : (
  <Table headers={ClientHeaders} data={ClientData}  />
)}

</div>
</div>
    </div>
    <div className='m-4'>
      <Input type="text" value={dataCount} placeholder="Nombre d'enr."></Input>
    </div>
    </div>
  )
}

export default ConsultationImmatriculation